import React from "react";
import { Divider, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import BSInput from "../../../common/js/components/BSInput";
import { styled  } from "@mui/material/styles";

const ResizeComment = styled(BSInput)(() => ({
    '& textarea': {
      resize: 'vertical',
    },
}));

const CompCommentBlock = (props) => {
    const { data, disableInputs, handleInputChange } = props;
    return (
        <Accordion defaultExpanded expanded>
            <AccordionSummary>Comp Comments</AccordionSummary>
            <Divider />
            <AccordionDetails>
                <ResizeComment
                    id="compNotes"
                    label="Public Comments"
                    placeholder="Comments entered here are PUBLIC and will be VISIBLE on reports and excel exports."
                    value={data.compNotes}
                    multiline
                    rows={5}
                    onChange={(e) => handleInputChange("compNotes", e.target.value)}
                    disabled={disableInputs}
                />
            </AccordionDetails>
        </Accordion>
    );
};

export default CompCommentBlock;
